<template>
  <v-dialog :value="value" max-width="900px" @input="onInput">
    <v-card>
      <v-card-title>
        {{ title }}
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="min-height: 450px">
        <iframe
          v-if="previewType === 'pdf' && previewUrl"
          :src="previewUrl"
          width="100%"
          height="500"
          style="border: 0"
        />
        <img
          v-else-if="previewType === 'image' && previewUrl"
          :src="previewUrl"
          alt="preview"
          style="max-width: 100%; max-height: 500px"
        />
        <div v-else class="text-center py-10">
          No se puede previsualizar este archivo.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="!canDownload" @click="$emit('download')">Descargar</v-btn>
        <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "HmnCandidateFilePreviewDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Vista previa CV",
    },
    previewType: {
      type: String,
      default: null,
    },
    previewUrl: {
      type: String,
      default: null,
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      if (!value) {
        this.$emit("close");
      }
    },
    closeDialog() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>
